import React, {useContext} from 'react';
import PermissionContext from "./PermissionContext";



// This component is meant to be used everywhere a restriction based on user permission is needed
const Restricted = ({to, or, allOf, children}) => {

    // We "connect" to the provider thanks to the PermissionContext
    const {isAllowedTo} = useContext(PermissionContext);

    // `allOf` requires every listed permission; takes precedence over `to`/`or`.
    if (Array.isArray(allOf) && allOf.length > 0) {
        return allOf.every(isAllowedTo) ? <>{children}</> : null;
    }

    // If the user has that permission, render the children
    if(isAllowedTo(to) || isAllowedTo(or)){
        return <>{children}</>;
    }

    // Otherwise, do not render anything
    return null;
};

export default Restricted;